export function imageSrc(media, src) {
  return media ? media.src : src;
}
export function imageAlt(media, alt) {
  return media && media.alt ? media.alt : alt;
}